import { Premium } from '../premium';

export class Ideo extends Premium {}
